import { Link } from "react-router-dom";
import { footerLinks, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-900 text-secondary-50 md:mt-24">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-secondary-950">
                <i className="ri-water-flash-fill text-xl"></i>
              </span>
              <div className="flex flex-col leading-none">
                <strong className="font-heading text-lg font-bold">{siteInfo.name}</strong>
                <span className="mt-1 text-[11px] text-secondary-200">{siteInfo.tagline}</span>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-secondary-100/80">
              {siteInfo.intro}
            </p>
            <div className="mt-6 flex flex-col gap-2 text-sm text-secondary-100/80">
              <span className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                {siteInfo.email}
              </span>
              <span className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-time-line"></i>
                </span>
                {siteInfo.workTime}
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold text-secondary-50">
                {group.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-secondary-100/75 transition-colors duration-200 hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-700/60 pt-6 text-xs text-secondary-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {siteInfo.since} - 2026 {siteInfo.name} · 站内人物与事件均为娱乐话题设定，请理性吃瓜
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors duration-200 hover:text-accent-300">
              内容原则
            </Link>
            <Link to="/contact" className="transition-colors duration-200 hover:text-accent-300">
              联系我们
            </Link>
            <a
              href="#top"
              className="flex items-center gap-1 transition-colors duration-200 hover:text-accent-300"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-up-line"></i>
              </span>
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}